import lodash from 'lodash';
(function (scope) {
  try {
    const isVconsole =
      lodash.includes(scope.location.search, 'vconsole') ||
      scope.localStorage.getItem('_le_vconsole');
    if (isVconsole) {
      scope.localStorage.setItem('_le_vconsole', 'true');
      if (scope.VConsole) {
        return new scope.VConsole();
      }
      const vcjs = document.createElement('script');
      vcjs.async = true;
      vcjs.src = `//cdn.staticfile.org/vConsole/3.14.6/vconsole.min.js`;
      vcjs.addEventListener('load', (event) => {
        // @ts-ignore
        const vConsole = new scope.VConsole();
        console.log('LENG ~ AppConfig', lodash.get(scope, '$nuxt'));
      });
      document.body.appendChild(vcjs);
    }
  } catch (error) {
    console.log('LENG: error', error);
  }
})(
  ('undefined' !== typeof process &&
    '[object process]' === {}.toString.call(process)) ||
    ('undefined' !== typeof navigator && navigator.product === 'ReactNative')
    ? global
    : self,
);
